import { render } from "./Arrow.atoms.vue?vue&type=template&id=f92934fe"
import script from "./Arrow.atoms.vue?vue&type=script&lang=js"
export * from "./Arrow.atoms.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__